export enum DiscountTab {
	ALL = 'all',
	ACTIVE = 'active',
	SCHEDULED = 'scheduled',
	EXPIRED = 'expired',
}

